import styled, { css } from 'styled-components'

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['16']};
  `,
)

export const Toolbar = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['12']};
  `,
)

export const TitleWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['16']};
    min-width: 0;
  `,
)

// Note: plain wrapper around the `backButton` prop (an arbitrary ReactNode) - exists purely as
// a styled-components identity so a consuming page's own styles (e.g.
// ReservationDetailsPageHeader) can target and reposition it via `grid-area` on narrower
// viewports without needing to know what's actually inside. No CSS of its own by default -
// invisible on every existing consumer of PageHeader.
export const BackButtonWrapper = styled.div``

export const BadgesWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const Title = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
  `,
)

export const ActionsWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    justify-content: flex-end;
    gap: ${theme.space['16']};
    margin-left: auto;
    /* Note: without this, ActionsWrapper's automatic minimum width falls back to the full
       min-content width of its children and it overflows Toolbar instead of wrapping onto
       its own row - the nested-flexbox min-width leak (same fix as Navigation in
       table-group.styled.ts). */
    min-width: 0;
  `,
)

export const NavbarWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space['12']};
  `,
)

export const NavbarItemCountContainer = styled.div<{ $isDanger?: boolean }>(
  ({ theme, $isDanger }) => {
    const baseStyles = css`
      border-radius: ${theme.border.radius['16']};
      min-width: 30px;
      text-align: center;
    `

    const dangerStyles = $isDanger
      ? css`
          background-color: ${theme.colors.orange500};
          color: ${theme.colors.white};
        `
      : ''

    return css`
      ${baseStyles}
      ${dangerStyles}
    `
  },
)
